<template>
  <v-row>
    <v-col cols="7" class="mx-n4">
      <v-card-title>Balises méta SEO</v-card-title>
    </v-col>
    <v-col cols="10" class="mt-n8">
      <v-text-field
        v-model="actionValue.metaTitle"
        label="Meta Titre"
        color="blue"
        clearable
        :rules="[isValid]"
      />
    </v-col>
    <v-col cols="10" class="mt-n8">
      <v-text-field
        v-model="actionValue.metaDescription"
        label="Meta Description"
        color="blue"
        clearable
        :rules="[isValid]"
      />
    </v-col>
  </v-row>
</template>

<script setup>
import { computed, ref } from 'vue';

const props = defineProps({ action: { type: Object, required: true } });

const actionValue = ref(props.action);

const isValid = computed(() => {
  if (!actionValue.value?.metaDescription?.trim() && !actionValue.value?.metaTitle?.trim()) return 'Un des champs doit avoir une valeur';

  return true;
});

</script>
